import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-content-home',
  templateUrl: './content-home.component.html',
  styleUrls: ['./content-home.component.css'],
    encapsulation:ViewEncapsulation.None
})
export class ContentHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
